import onDeviceAiUpdate from './on-device-ai-update';

// Add new posts here — newest first
export const posts = [onDeviceAiUpdate];

export default posts;
